/** Endpoints #10, #16, #17 — scrape history, manual enqueue, run detail. */
import { z } from 'zod';
import { MAX_RUNS_LIMIT } from './common.js';
/** #10 `GET /api/profiles/:id/runs` */
export const RunsQuerySchema = z.object({
    offset: z.coerce.number().int().nonnegative().default(0),
    limit: z.coerce.number().int().positive().max(MAX_RUNS_LIMIT).default(25),
});
/** #16 `POST /api/scrape` — union of the two id sets, server-deduped. */
export const ScrapeRequestBodySchema = z
    .strictObject({
    profileIds: z.array(z.number().int().positive()).max(1000).optional(),
    groupIds: z.array(z.number().int().positive()).max(1000).optional(),
    /** One-off backfill window; bounds mirror the `backfillMonths` setting (`dto/settings.ts`). */
    backfillMonths: z.number().int().min(1).max(120).optional(),
})
    .refine((body) => (body.profileIds?.length ?? 0) + (body.groupIds?.length ?? 0) > 0, 'at least one profileId or groupId is required')
    .refine((body) => body.backfillMonths === undefined ||
    (body.profileIds?.length === 1 && (body.groupIds?.length ?? 0) === 0), 'backfillMonths requires exactly one profileId and no groupIds');
export const SCRAPE_SKIP_REASONS = ['archived', 'already_active', 'no_active_scrapers'];
//# sourceMappingURL=runs.js.map